
const digest = '8e372a2462ab4d701b608162b9ccdcc90f856a8573e2c0a559f4e62bfd6f9e3e';
const css = `._lightboxjs_80tal_1 {
  margin: 0;
  padding: 0;
}

._lightboxjs_80tal_1 * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

._slideshowBtn_80tal_37 {
  padding-bottom: 2px;
}

._closeIcon_80tal_45:hover,
._closeIcon_80tal_45:focus,
._iconsHeader_80tal_49 svg:hover,
._iconsHeader_80tal_49 svg:focus,
._prev1_80tal_53 span:hover,
._next1_80tal_55:hover,
._icon_80tal_49:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

._prevIcon_80tal_69:hover,
._nextIcon_80tal_71:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

._show_80tal_81 {
  display: flex;
}

._displayHidden_80tal_89 {
  display: none;
}

._thumbnail_80tal_97 {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

._next1_80tal_55 {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

._prev1_80tal_53 {
  left: 2%;
  padding-right: 2vw;
  padding-left: 3vw;
}

._thumbnails_80tal_135 {
  transition: border 0.3s;
}

._thumbnail_80tal_97 {
  display: inline;
}

._thumbnailsWithCaption_80tal_151 {
  width: 90%;
}

._thumbnailsOuterContainer_80tal_159 {
  position: absolute;
  bottom: 4%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

._navigationDots_80tal_183 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  ._imageSlide_80tal_199 {
    height: 67vw;
    width: 60%;
  }

  ._thumbnailsOuterContainer_80tal_159 {
    position: absolute;
    bottom: 7%;
    width: 100vw;
    /* width: 100%; */
  }

  ._thumbnailsAndCaption_80tal_223 {
    height: 23vh;
    bottom: 2%;

  }

  ._hideControlsBar_80tal_235 ._slideshowImg_80tal_235 {
    /* height: 100vh; */
  }

  ._rotateImgInnerContainer_80tal_243 {
    top: 8%;
  }

  ._hideControlsBar_80tal_235 ._slideshowInnerContainer_80tal_251 {
    top: 0;
  }

  ._thumbnail_80tal_97 {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  ._videoThumbnailsOuterContainer_80tal_271 {
    bottom: 2%;
  }

  ._imgTitleContainer_80tal_279 {
    padding-bottom: 16px;
    width: 100vw;
    margin-top: 0;
    margin-bottom: 0;
  }

  ._thumbnails_80tal_135 {
    margin-left: auto;
    margin-right: auto;
  }

  ._next1_80tal_55 {
    right: 0.9%;
  }

  ._prev1_80tal_53 {
    left: 1.5%;
  }
}

._thumbnail_80tal_97 {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}



._thumbnailsOuterContainerMetadata_80tal_339 {
  width: 78vw;
}

._videoThumbnailsOuterContainer_80tal_271 {
  bottom: 5%;
}

._thumbnailsAndCaption_80tal_223 {
  height: 19vh;
}

._htmlVideoOuterContainer_80tal_363 video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

._caption_80tal_375 {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

._galleryImg_80tal_395 {
  cursor: pointer;
  margin: 0.2em;
}

._modalContainer_80tal_405 {
  width: 100vw;
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

._slideshowAnimContainer_80tal_443 {
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

._fullScreenContainer_80tal_479 img {
  height: 100vh;
  max-width: 100%;
  /* max-height: 100vh; */
}

._imageInnerContainer_80tal_491 img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

._imageInnerContainer_80tal_491 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._magnifyWrapper_80tal_529 {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

._slideshowInnerContainer_80tal_251 {
  position: fixed; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 12%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._slideshowInnerVideoContainer_80tal_569 {
  top: 6%;
}

._slideshowInnerContainerThumbnails_80tal_577 {
  top: 12%;
}

._hideControlsBar_80tal_235  {
  top: 0;
}

._fullScreenContainer_80tal_479 {
  top: 0;
}

._lightboxContainer_80tal_601 {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

._next1_80tal_55,
._prev1_80tal_53 {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: color 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  /* border-radius: 30px; */
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
  
  background: none !important;
  border: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}



._next1_80tal_55:hover,
._prev1_80tal_53:hover {
  color: rgb(230, 230, 230);
}

._slideshowAnimImg_80tal_683 {
  position: absolute;
  max-width: 100vw;
}

._controls_80tal_693 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

._iconsHeader_80tal_49 {
  color: white;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

._iconHeaderDefault_80tal_727 {
  position: absolute;
  top: 10px;
  right: 45px;
}

._ytVideo_80tal_739 {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

._videoOuterContainer_80tal_751 {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

._htmlVideoOuterContainer_80tal_363 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._customVideoContainer_80tal_779, ._customEmbedContainer_80tal_779 {
  margin-left: auto;
  margin-right: auto;
}

._videoIconsHeader_80tal_789 {
  position: fixed;
  top: 4%;
  right: 3%;
}

._lightbox_80tal_1 ._iconsHeader_80tal_49 svg {
  transition: 0.3s all;
}

._iconsHeader_80tal_49 svg:active {
  transform: scale(0.97);
}

._imgTitle_80tal_279 {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._iconsHeader_80tal_49 svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

._icon_80tal_49 {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  ._iconsHeader_80tal_49 {
    top: 3%;
  }

  ._slideshowAnimContainer_80tal_443 {
    width: 100vw;
  }

  ._iconsHeader_80tal_49 svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  ._lightboxjs_80tal_1 img {
    cursor: pointer;
  }

  ._thumbnail_80tal_97 {
    height: 9vh;
    /* width: 22vw; */
  }

  ._next1_80tal_55 {
    top: calc(48% - 20px);
  }

  ._prev1_80tal_53 {
    top: calc(48% - 20px);

  }

  ._iconHeaderCenter_80tal_923 {
    width: 100vw; 
    display: flex;
    flex-direction: row;
    cursor: pointer;
    position: fixed;
    top: 10px;
    justify-content: center;
    left: 0;
  }

}

@media screen and (min-width: 39em) {
  ._slideshowAnimContainer_80tal_443 {
    width: 100vw;
  }

  ._slideshowInnerContainer_80tal_251 {
    /* width: 100vw;
    height: 95vh;
    position: absolute; */
  }

  ._imgTitleContainer_80tal_279 {
    padding-bottom: 0px;
  }
  

  ._next1_80tal_55 {
    right: 0.7%;
  }

  ._iconHeaderCenter_80tal_923 {
    width: 100%; 
    display: flex;
    flex-direction: row;
    cursor: pointer;
    position: fixed;
    top: 10px;
    justify-content: center;
    left: 0;

  
  }

  /* .thumbnailsOuterContainer {
    bottom: 10%;
  } */

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */

  ._fullScreenContainer_80tal_479 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._fullScreenContainer_80tal_479 img {
    height: 100vh;
  }

  ._thumbnails_80tal_135 {
    margin-top: 0.6em;
  }

  ._thumbnail_80tal_97 {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  ._iconsHeader_80tal_49 svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  ._prev1_80tal_53 {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  ._imageSlide_80tal_199 {
    height: 70vh;
    width: 80vw;
  }

  ._innerContainerWithTopCaption_80tal_1115 {
    top: 8%;
  }

  ._slideshowImgFullscreen_80tal_1123 {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  ._thumbnailsAndCaption_80tal_223 {
    bottom: 0%;
  }
  
  ._rotateImgInnerContainer_80tal_243 {
    top: 2%;
  }

  ._slideshowInnerContainer_80tal_251 img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  ._fullScreenContainer_80tal_479 img {
    width: 80vw;
  }

  ._slideshowInnerContainerFullScreen_80tal_1175 {
    top: 0%;
  }

  ._fullScreenLightboxImg_80tal_1183 {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  ._slideshowInnerContainerImgMetadata_80tal_1195 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ._slideshowInnerContainerFullScreen_80tal_1175 {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  ._slideshowInnerContainerFullScreen_80tal_1175 img {
    object-fit: contain;
  }

  ._thumbnails_80tal_135 {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  ._thumbnails_80tal_135::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ._opacity-fade_80tal_1249 {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  ._thumbnailsOuterContainer_80tal_159 {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
  }

  ._thumbnailsAndCaption_80tal_223 {
    bottom: 0%;
  }

  ._thumbnail_80tal_97,
  ._imageSliderThumbnails_80tal_1285 img {
    height: 10vh;
    /* width: 7em; */
  }

  ._slideshowAnimContainer_80tal_443 {
    width: 100vw;
  }

  /* .slideshowInnerContainer {
    width: 100vw;
    height: 95vh;
  } */

  ._hideControlsBar_80tal_235 {
    /* height: 100vh; */
  }

  ._fullScreenContainer_80tal_479 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._iconsHeader_80tal_49 svg {
    /* width: 37px;
      font-size: 34px; */
  }

  ._prev1_80tal_53 {
    left: 2%;
    padding-right: 2vw;
  }

  ._next1_80tal_55 {
    right: 2.4%;
  }

  
  ._slideshowImgMetadata_80tal_1361 {
    width: 78vw;
  }

  ._prev1Metadata_80tal_1369 {
    left: 1%;
  }

  ._navigationDots_80tal_183 {
    gap: 8px;
  }

 
}

@media screen and (min-width: 53em) {
  
  ._slideshowImg_80tal_235 {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  ._slideshowImgWithCaption_80tal_1411 {
    height: 68vh;
  }

  ._hideControlsBar_80tal_235 ._slideshowImg_80tal_235, ._hideControlsBarAndCaption_80tal_1419 ._slideshowImg_80tal_235  {
    padding-top: 12vh;
  }

  ._fullScreenContainer_80tal_479 ._slideshowImg_80tal_235 {
    padding-top: 0vh;
  }


  ._lightboxImg_80tal_1437 {
      /* height: 70vh; */
  }

  ._thumbnail_80tal_97 {
    width: 95px;
    max-width: 80px;
  } 

  ._slideshowImgMetadata_80tal_1361 {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  ._slideshowInnerContainer_80tal_251 img {
    /* width: 60vw; */
  }

  ._fullScreenContainer_80tal_479 img {
    width: 80vw;
  }
}

._lightIcon_80tal_1487,
._lightIcon_80tal_1487 svg {
  background-color: white;
  color: black;
}

._lightIcon_80tal_1487:hover,
._lightIcon_80tal_1487 svg:hover {
  background-color: white;
  color: black;
  fill: black;
}

._darkIcon_80tal_1513,
._darkIcon_80tal_1513 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
  fill: silver;
}

._darkIcon_80tal_1513:hover,
._darkIcon_80tal_1513 svg:hover {
  color: rgba(107, 107, 107, 0.8);
  fill: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
._lightHeaderIcon_80tal_1543 svg {
  background-color: white;
  color: black;
  fill: black;
}

._lightHeaderIcon_80tal_1543 svg:hover {
  background-color: white;
  color: rgb(24, 24, 24, 0.8);
  fill: rgb(24, 24, 24, 0.8);

}

._darkHeaderIcon_80tal_1569 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
  fill: #626b77;
}

._darkHeaderIcon_80tal_1569 svg:hover {
  color: rgba(99, 99, 99, 0.8);
  fill: rgba(99, 99, 99, 0.8);
}

._magnifierImage_80tal_1593 {
  object-fit: contain;
}

._thumbnails_80tal_135 ._active_80tal_1601 {
  border: solid rgb(107, 133, 206) 2px;
}

._inactiveThumbnailBorder_80tal_1609 {
  border: solid transparent 2px;
}

._thumbnails_80tal_135 {
  width: 95%;
}

._emblaThumbs_80tal_1625 {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 40em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  ._imgTitleContainer_80tal_279 {
    /* position: absolute;
    top: 12%; */
  }

  ._slideshowImg_80tal_235 {
    height: 100vh;
  }
}

@media screen and (max-width: 53em) {
  ._fullScreenSlideshowImg_80tal_1671 {
    margin-top: auto;
    margin-bottom: auto;
  }
}

@media screen and (max-width: 44em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */
  ._thumbnailsOuterContainer_80tal_159 {
    bottom: 11%;
  }

  ._thumbnailsAndCaption_80tal_223 {
    bottom: 4%;
  }
  
  ._imgTitleContainer_80tal_279 {
    /* position: absolute;
    top: 5%; */
  }
}

@media screen and (max-width: 46em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 7%;
  } */
}

@media screen and (max-width: 49em) and (min-width: 45em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  /* .imgTitleContainer {
    position: absolute;
    top: 5%;
  } */
}

@media screen and (max-width: 29em) {
  ._fullScreenContainer_80tal_479 img {
    object-fit: cover;
  }

  ._emblaThumbs_80tal_1625 {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }



  ._htmlVideo_80tal_363 {
    margin-top: 5vh;
  }

  ._thumbnails_80tal_135 {
    width: 98%;
  }

  ._thumbnail_80tal_97 {
    width: 80px;
    max-width: 80px;
  }

  ._htmlVideoOuterContainer_80tal_363 video {
    max-height: 65vh;
  }

  ._videoIconsHeader_80tal_789 {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  ._videoOuterContainer_80tal_751 {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  ._htmlVideoOuterContainer_80tal_363 {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 115px;
  }

  ._slideshowInnerVideoContainer_80tal_569 {
    top: 3%;
  }

  ._next1_80tal_55,
  ._prev1_80tal_53 {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  ._next1_80tal_55 {
    padding-left: 4vw;
  }

  ._prev1_80tal_53 {
    padding-right: 4vw;
  }

  ._iconsHeader_80tal_49 {
    /* font-size: 28px; */
  }

}

@media screen and (max-width: 53em) {
  ._slideshowImg_80tal_235 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._slideshowImg_80tal_235 img {
    margin-left: auto;
    margin-right: auto;
  }

  ._slideshowInnerContainerFullScreen_80tal_1175 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  ._containImg_80tal_1981 {
    object-fit: contain;
  }
}

._fullScreenContainer_80tal_479 img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

._thumbnails_80tal_135 {
  text-align: center;
  white-space: nowrap;
}

._reactTransformComponent_80tal_2013 {
  margin-left: auto;
  margin-right: auto;
}

._magnifierImage_80tal_1593 {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
._loader_80tal_2035 {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 35%;
  left: 50%;
  animation: _rotation_80tal_1 1s linear infinite;
}

@keyframes _rotation_80tal_1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

._dayLoader_80tal_2081 {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

._nightLoader_80tal_2091 {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

._lightboxImg_80tal_1437 {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

._controls_80tal_693 button, ._closeButton_80tal_2113, ._closeButtonRounded_80tal_2113 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

._controls_80tal_693 svg {
  box-sizing: border-box;
}

._closeButton_80tal_2113 svg, ._closeButtonRounded_80tal_2113 svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

._closeButton_80tal_2113 {
  padding-top: 3px;
}

._closeButtonRounded_80tal_2113 {
  cursor: pointer;

}

._closeButtonRounded_80tal_2113 svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

._thumbnailsAndCaption_80tal_223 {
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

._thumbnailsWithCaption_80tal_151 {
  margin-top: 0em;
}

._slideImageAndCaption_80tal_2205 {
  top: 9%;
}

._slideImageAndCaption_80tal_2205._hideControlsBar_80tal_235 {
  top: 0;
}

._slideshowAnimContainer_80tal_443 {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
._thumbnails_80tal_135::-webkit-scrollbar {
  display: none;
}

._roundedBorder_80tal_2237 {
  border-radius: 20px;
}

._maxWidthFull_80tal_2245 {
  max-width: 100%;
}

._maxWidthWithoutMagnifier_80tal_2253 {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 180px;
  }
  
}

@media screen and (max-width: 440px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  ._iconHeaderDefault_80tal_727 {
    position: fixed;
    left: 94px;
  }
}

@media screen and (max-width: 325px) {
  ._iconsHeader_80tal_49 {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  ._iconsHeader_80tal_49 {
    position: fixed;
    left: 30px;
  }
}

._lightboxVideo_80tal_2391 {
  margin-left: auto;
  margin-right: auto;
}

._navigation-wrapper_80tal_2401 {
  position: relative;
}

._dots_80tal_2409 {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

._dot_80tal_2409 {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

._dot_80tal_2409:focus {
  outline: none;
}

._dot_80tal_2409._active_80tal_1601 {
  background: #000;
}

._arrow_80tal_2459 {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

._leftArrow_80tal_2489 {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._rightArrow_80tal_2503 {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._arrow_80tal_2459:hover {
  color: rgb(230, 230, 230);
}

._arrow--disabled_80tal_2527,
._arrow--disabled_80tal_2527:hover {
  color: rgba(255, 255, 255, 0.5);
}

._navDotsMargin_80tal_2537 {
  margin-top: 12px;
}

._inactiveThumbnailBorderImgSlider_80tal_2545 {
  border: 'solid transparent 2px';
}

._ytVideoImgSlider_80tal_2553 {
  width: 100%;
  height: 100%;
}

._ytVideoImgSlider_80tal_2553 iframe {
  width: 100%;
  height: 100%;
}

._outerYTVideoImgSlider_80tal_2573 {
  height: 100%;
}

._lightboxjs_80tal_1 iframe {
  margin: none;
  padding: none;
  border: none;
}

._imgSliderArrow_80tal_2593 {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

._thumbnails_80tal_135 {
  margin-left: auto;
  margin-right: auto;
}

._cursorPointer_80tal_2615 {
  cursor: pointer;
}

._lightboxjsIcon_80tal_2623 > * { color: inherit; fill: inherit }

._embla_80tal_1625 {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

._emblaViewport_80tal_2643 {
  overflow: hidden;
  width: 100vw;
}

._emblaContainer_80tal_2653 {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

._emblaContainerImgMetadata_80tal_2683 {
  width: 78vw;
  max-width: 78vw;
  height: 80vh;
}

._imgdrag_80tal_2695 ._emblaSlide_80tal_2695 {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

._emblaThumbsViewport_80tal_2715 {
  overflow: hidden;
}

._emblaThumbsContainer_80tal_2723 {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

._emblaThumbsContainer_80tal_2723::before, ._emblaThumbsContainer_80tal_2723::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


._emblaThumbsSlide_80tal_2759 {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

._emblaThumbsSlideImg_80tal_2773 {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

._mlAuto_80tal_2787 {
  margin-left: auto;
}

._metadata_80tal_2795 {
  color: white;
}

._emblaSlideGrid_80tal_2803 {
  display: flex;
}

._metadata_80tal_2795 {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

._metadataPanel_80tal_2825 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

._metadataInnerContainer_80tal_2837 {
  padding-left: 7vw;
}

._metadataInnerContainer_80tal_2837 span {
  display: block;
}


._imgMetadataCloseBtn_80tal_2855 {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
._reactTransformWrapper_80tal_2877 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -khtml-user-select: none; /* Konqueror HTML */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

._reactTransformComponent_80tal_2013 {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

._reactTransformComponent_80tal_2013 img {
  pointer-events: none;
}

._navigationDot_80tal_183 {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

._navigationDotContainer_80tal_2961 {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

._imgfade_80tal_2975._emblaContainer_80tal_2653 {
  transform: none !important; /* override Embla */
  display: flex;
  /* height: 250px; */
}

._notFullScreen_80tal_2987 {
  top: 0;
}

._imgfade_80tal_2975._emblaSlide_80tal_2695 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: 0; */
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

._imgFadeWithTopCaption_80tal_3023 {
  top: 16%;
  position: fixed;
}

._imgfade_80tal_2975._emblaSlideSelected_80tal_3033 {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

._imgfade_80tal_2975._emblaSlide_80tal_2695:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

._fullImg_80tal_3059 {
  height: 84vh;
  max-height: 84vh;
  object-fit: contain;
}

._rotateImg90Deg_80tal_3071{
transform: rotate(90deg);
transition: transform 1s linear;
}  

._rotate_img_80tal_3081 {
transition: transform 0.7s linear;
}

._fullScreenContainer_80tal_479 img {
/* max-height: 100vh; */
}

._slideshowImg_80tal_235 img {
height: 100%;
}

._zoomInCursor_80tal_3105 {
  cursor: zoom-in;
}

._zoomOutCursor_80tal_3113 {
  cursor: zoom-out;
}

._lightboxjsBtn_80tal_3121:focus {
  outline: none;
}

._lightboxjsBtn_showOutline_80tal_3129:focus-visible {
  outline: 2px solid #00aaff;
  outline-offset: 2px;
}

._lightboxjsBtn_80tal_3121::-webkit-focus-inner {
  border: 0;
}

._lightboxjsBtn_80tal_3121 {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background: none;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"lightboxjs":"_lightboxjs_80tal_1","slideshowBtn":"_slideshowBtn_80tal_37","closeIcon":"_closeIcon_80tal_45","iconsHeader":"_iconsHeader_80tal_49","prev1":"_prev1_80tal_53","next1":"_next1_80tal_55","icon":"_icon_80tal_49","prevIcon":"_prevIcon_80tal_69","nextIcon":"_nextIcon_80tal_71","show":"_show_80tal_81","displayHidden":"_displayHidden_80tal_89","thumbnail":"_thumbnail_80tal_97","thumbnails":"_thumbnails_80tal_135","thumbnailsWithCaption":"_thumbnailsWithCaption_80tal_151","thumbnailsOuterContainer":"_thumbnailsOuterContainer_80tal_159","navigationDots":"_navigationDots_80tal_183","imageSlide":"_imageSlide_80tal_199","thumbnailsAndCaption":"_thumbnailsAndCaption_80tal_223","hideControlsBar":"_hideControlsBar_80tal_235","slideshowImg":"_slideshowImg_80tal_235","rotateImgInnerContainer":"_rotateImgInnerContainer_80tal_243","slideshowInnerContainer":"_slideshowInnerContainer_80tal_251","videoThumbnailsOuterContainer":"_videoThumbnailsOuterContainer_80tal_271","imgTitleContainer":"_imgTitleContainer_80tal_279","thumbnailsOuterContainerMetadata":"_thumbnailsOuterContainerMetadata_80tal_339","htmlVideoOuterContainer":"_htmlVideoOuterContainer_80tal_363","caption":"_caption_80tal_375","galleryImg":"_galleryImg_80tal_395","modalContainer":"_modalContainer_80tal_405","slideshowAnimContainer":"_slideshowAnimContainer_80tal_443","fullScreenContainer":"_fullScreenContainer_80tal_479","imageInnerContainer":"_imageInnerContainer_80tal_491","magnifyWrapper":"_magnifyWrapper_80tal_529","slideshowInnerVideoContainer":"_slideshowInnerVideoContainer_80tal_569","slideshowInnerContainerThumbnails":"_slideshowInnerContainerThumbnails_80tal_577","lightboxContainer":"_lightboxContainer_80tal_601","slideshowAnimImg":"_slideshowAnimImg_80tal_683","controls":"_controls_80tal_693","iconHeaderDefault":"_iconHeaderDefault_80tal_727","ytVideo":"_ytVideo_80tal_739","videoOuterContainer":"_videoOuterContainer_80tal_751","customVideoContainer":"_customVideoContainer_80tal_779","customEmbedContainer":"_customEmbedContainer_80tal_779","videoIconsHeader":"_videoIconsHeader_80tal_789","lightbox":"_lightbox_80tal_1","imgTitle":"_imgTitle_80tal_279","iconHeaderCenter":"_iconHeaderCenter_80tal_923","innerContainerWithTopCaption":"_innerContainerWithTopCaption_80tal_1115","slideshowImgFullscreen":"_slideshowImgFullscreen_80tal_1123","slideshowInnerContainerFullScreen":"_slideshowInnerContainerFullScreen_80tal_1175","fullScreenLightboxImg":"_fullScreenLightboxImg_80tal_1183","slideshowInnerContainerImgMetadata":"_slideshowInnerContainerImgMetadata_80tal_1195","opacityFade":"_opacity-fade_80tal_1249","imageSliderThumbnails":"_imageSliderThumbnails_80tal_1285","slideshowImgMetadata":"_slideshowImgMetadata_80tal_1361","prev1Metadata":"_prev1Metadata_80tal_1369","slideshowImgWithCaption":"_slideshowImgWithCaption_80tal_1411","hideControlsBarAndCaption":"_hideControlsBarAndCaption_80tal_1419","lightboxImg":"_lightboxImg_80tal_1437","lightIcon":"_lightIcon_80tal_1487","darkIcon":"_darkIcon_80tal_1513","lightHeaderIcon":"_lightHeaderIcon_80tal_1543","darkHeaderIcon":"_darkHeaderIcon_80tal_1569","magnifierImage":"_magnifierImage_80tal_1593","active":"_active_80tal_1601","inactiveThumbnailBorder":"_inactiveThumbnailBorder_80tal_1609","emblaThumbs":"_emblaThumbs_80tal_1625","fullScreenSlideshowImg":"_fullScreenSlideshowImg_80tal_1671","htmlVideo":"_htmlVideo_80tal_363","containImg":"_containImg_80tal_1981","reactTransformComponent":"_reactTransformComponent_80tal_2013","loader":"_loader_80tal_2035","rotation":"_rotation_80tal_1","dayLoader":"_dayLoader_80tal_2081","nightLoader":"_nightLoader_80tal_2091","closeButton":"_closeButton_80tal_2113","closeButtonRounded":"_closeButtonRounded_80tal_2113","slideImageAndCaption":"_slideImageAndCaption_80tal_2205","roundedBorder":"_roundedBorder_80tal_2237","maxWidthFull":"_maxWidthFull_80tal_2245","maxWidthWithoutMagnifier":"_maxWidthWithoutMagnifier_80tal_2253","lightboxVideo":"_lightboxVideo_80tal_2391","navigationWrapper":"_navigation-wrapper_80tal_2401","dots":"_dots_80tal_2409","dot":"_dot_80tal_2409","arrow":"_arrow_80tal_2459","leftArrow":"_leftArrow_80tal_2489","rightArrow":"_rightArrow_80tal_2503","arrowDisabled":"_arrow--disabled_80tal_2527","navDotsMargin":"_navDotsMargin_80tal_2537","inactiveThumbnailBorderImgSlider":"_inactiveThumbnailBorderImgSlider_80tal_2545","ytVideoImgSlider":"_ytVideoImgSlider_80tal_2553","outerYtVideoImgSlider":"_outerYTVideoImgSlider_80tal_2573","imgSliderArrow":"_imgSliderArrow_80tal_2593","cursorPointer":"_cursorPointer_80tal_2615","lightboxjsIcon":"_lightboxjsIcon_80tal_2623","embla":"_embla_80tal_1625","emblaViewport":"_emblaViewport_80tal_2643","emblaContainer":"_emblaContainer_80tal_2653","emblaContainerImgMetadata":"_emblaContainerImgMetadata_80tal_2683","imgdrag":"_imgdrag_80tal_2695","emblaSlide":"_emblaSlide_80tal_2695","emblaThumbsViewport":"_emblaThumbsViewport_80tal_2715","emblaThumbsContainer":"_emblaThumbsContainer_80tal_2723","emblaThumbsSlide":"_emblaThumbsSlide_80tal_2759","emblaThumbsSlideImg":"_emblaThumbsSlideImg_80tal_2773","mlAuto":"_mlAuto_80tal_2787","metadata":"_metadata_80tal_2795","emblaSlideGrid":"_emblaSlideGrid_80tal_2803","metadataPanel":"_metadataPanel_80tal_2825","metadataInnerContainer":"_metadataInnerContainer_80tal_2837","imgMetadataCloseBtn":"_imgMetadataCloseBtn_80tal_2855","reactTransformWrapper":"_reactTransformWrapper_80tal_2877","navigationDot":"_navigationDot_80tal_183","navigationDotContainer":"_navigationDotContainer_80tal_2961","imgfade":"_imgfade_80tal_2975","notFullScreen":"_notFullScreen_80tal_2987","imgFadeWithTopCaption":"_imgFadeWithTopCaption_80tal_3023","emblaSlideSelected":"_emblaSlideSelected_80tal_3033","fullImg":"_fullImg_80tal_3059","rotateImg90Deg":"_rotateImg90Deg_80tal_3071","rotateImg":"_rotate_img_80tal_3081","zoomInCursor":"_zoomInCursor_80tal_3105","zoomOutCursor":"_zoomOutCursor_80tal_3113","lightboxjsBtn":"_lightboxjsBtn_80tal_3121","lightboxjsBtnShowOutline":"_lightboxjsBtn_showOutline_80tal_3129"};
export { css, digest };
  